<template>

    <header class="flex-center bg-white">
      <div id="topbar">
        <div class="logo"><a href="/"><img src="/img/AuthroizeLocalLogoLargeWhite.png" /></a></div>
        <div class="manage" v-if="activeUserInfo.permissionLevel===2048">
<!--          <span>Manage:</span>
          <select class="rest-select ml-2 manageUser" v-model="selectedUserId" @change="onUserChange">
            <option value="-1">Admin</option>
            <option v-for="(user, index) in users" :key="index" :value="user._id">{{user.company.name}} ({{user.email}})</option>
          </select>-->
          <b-input-group class="mt-3" style="border-radius: 8px;min-width: 512px; padding-bottom:15px">
            <template #append>
              <b-input-group-text style="background: var(--Primery-Primery-Main-50, #F08028);border: none">
                <div style="">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M26.6971 24.0204L22.4135 19.7368C22.2202 19.5435 21.9581 19.4361 21.6831 19.4361H20.9828C22.1686 17.9194 22.8733 16.0118 22.8733 13.9366C22.8733 9 18.8733 5 13.9366 5C9 5 5 9 5 13.9366C5 18.8733 9 22.8733 13.9366 22.8733C16.0118 22.8733 17.9194 22.1686 19.4361 20.9828V21.6831C19.4361 21.9581 19.5435 22.2202 19.7368 22.4135L24.0204 26.6971C24.4243 27.101 25.0773 27.101 25.4769 26.6971L26.6928 25.4812C27.0967 25.0773 27.0967 24.4243 26.6971 24.0204ZM13.9366 19.4361C10.899 19.4361 8.43716 16.9785 8.43716 13.9366C8.43716 10.899 10.8947 8.43716 13.9366 8.43716C16.9742 8.43716 19.4361 10.8947 19.4361 13.9366C19.4361 16.9742 16.9785 19.4361 13.9366 19.4361Z" fill="white"/>
                </svg>
              </div></b-input-group-text>
            </template>
            <select class="rest-select ml-2 manageUser" v-model="selectedUserId" @change="onUserChange">
              <option value="-1">Admin</option>
              <option v-for="(user, index) in users" :key="index" :value="user._id">{{user.company.name}} ({{user.email}})</option>
            </select>
          </b-input-group>
        </div>
        <div class="user" @click="toggleMenu = !toggleMenu">
          <div class="user-icon">{{ getInitials(fullName) }}</div>
          <div class="user-info">
            <div class="user-name">
              <span style="float: left; padding-right: 5px;">{{ fullName }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6.12808 8H17.2843C18.2875 8 18.789 9.21406 18.0812 9.92188L12.5031 15.5C12.0625 15.9406 11.35 15.9406 10.914 15.5L5.3312 9.92188C4.62339 9.21406 5.12495 8 6.12808 8Z" fill="white"/>
              </svg>
            </div>
            <div class="user-role">{{activeUserInfo.permissionLevel===2048 ? 'Admin' : 'User'}}</div>
          </div>
        </div>
        <div v-if="toggleMenu" id="user-menu" class="user-menu-cont active">
          <ul class="user-menu">
            <li class="user-menu-item"><a href="/account"><i class="fas fa-cog"></i> Account Settings</a></li>
            <li class="user-menu-item"><a href="/billing"><i class="fas fa-file-invoice-dollar"></i> Billing</a></li>
            <li class="user-menu-item"><a href="/help"><i class="fas fa-question-circle"></i> Help</a></li>
            <li class="user-menu-item"><a @click="logout"><i class="fas fa-sign-out-alt"></i>Logout</a></li>
          </ul>
        </div>
      </div>
    </header>
</template>

<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import EditDropDown from './components/EditEventPopup.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Logo                 from '../Logo.vue'
import HNavMenuGroup from '../horizontal-nav-menu/HorizontalNavMenuGroup'
import HNavMenuHeader from '../horizontal-nav-menu/HorizontalNavMenuHeader'
import HNavMenuItem from '../horizontal-nav-menu/HorizontalNavMenuItem'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      toggleMenu: false,
      selectedUserId: -1,
      users: []
    }
  },
  mounted () {
    if (this.activeUserInfo.permissionLevel === 2048) {
      this.getUsers()
    }
    document.addEventListener('click', this.closeUserMenu)
  },
  methods: {
    closeUserMenu (event) {
      // Eğer tıklanan alan user menüsü içinde değilse menüyü kapat
      if (this.toggleMenu && !event.target.closest('.user') && !event.target.closest('#user-menu')) {
        this.toggleMenu = false
      }
    },
    getInitials (name) {
      // Split the name into parts by removing whitespace
      const parts = name.trim().split(' ')
      let initials = ''

      // Get the first letter of each part, converted to uppercase
      for (let i = 0; i < parts.length; i++) {
        initials += parts[i][0].toUpperCase()
      }

      return initials
    },
    logout () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')
      localStorage.clear()

      // This is just for demo Purpose. If user clicks on logout -> redirect
      location.reload()
    },
    getUsers () {
      const payload = {
        page: 0,
        limit: 9999,
        filter: 'all'
      }
      this.$store.dispatch('getUsers', payload)
        .then((response) => {
          this.users = response.data.data
          this.maxItems = response.data.maxItems
          if (this.selectedUser) {
            this.selectedUserId = this.selectedUser._id
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    onUserChange () {
      let selectedUser = this.users.filter((user) => {
        return user._id === this.selectedUserId
      })

      if (this.selectedUserId === -1) {
        selectedUser = null
      } else {
        selectedUser = selectedUser[0]
      }
      localStorage.setItem('selectedUser', selectedUser ? JSON.stringify(selectedUser) : null)
      location.reload()
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    EditDropDown,
    ProfileDropDown,
    HNavMenuGroup,
    HNavMenuHeader,
    HNavMenuItem
  },
  computed: {
    fullName () {
      return ` ${this.activeUserInfo.name} ${this.activeUserInfo.lastname ? this.activeUserInfo.lastname : '' }`
    },
    event_data () {
      return this.$store.state.event_data.filter((event) => {
        if (event.status === 'None') {
          return event
        }
      })
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#0e0f13'
        } else {
          color = '#14171c'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 },
    selectedUser () {
      return JSON.parse(localStorage.getItem('selectedUser'))
    }
  }
}

</script>
<style lang="scss">
.manage {
  color: white;
  background-color: transparent !important;
}
select.manageUser{
  color: #003451;
  padding-left: 10px;
  background-color: #fff !important;
  border-radius: 8px 0 0 8px;
}
.user-icon {
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;border-radius: 8px;
  background: #B2ECFF;color: var(--Non-Contextual-Cyan-On-Muted, #002742);
  text-align: center;
  /* Paragraph Styles/Paragraph Large */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  float: left;
  margin-right: 10px;
}
.user-info {
  float: right;
}
.user-name {
  color: #FFF;
  text-align: center;
  /* Paragraph Styles/Paragraph Large */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}
.user-role {
  color: var(--Main-Color-Main-60, #0095DF);
  font-variant-numeric: lining-nums proportional-nums;
  /* Paragraph Styles/Paragraph Small */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}
#user-menu {
  width: 241px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #FFF;
  box-shadow: 0px 4px 12px 0px rgba(0, 52, 81, 0.40);
  /* margin-top: 10px; */
  top: 78px;
  right: 21px;
  z-index: 10000
}
.user-menu-item {
  color: var(--Cold-Gray-Cold-Gray-40, #AEB8B8);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.32px;
  padding: 10px;
  padding-left: 20px;
}
.user-menu {
  padding: 10px 0;
}
</style>

